'use client';

import { Trans } from '@lingui/macro';
import { Download } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import {
  CascadingHoverMenus,
  CascadingMenuItem,
} from '@prismo-io/design-system';
import {
  LanguageCode,
  type LanguageCodeT,
  type ToolsOrganizationsT,
  type ToolsProjectsT,
} from '@prismo-io/schemas';
import { type FC, useCallback } from 'react';
import { DownloadPdfButton } from './download-pdf-button';
import { useDownloadPDFDiagnostic } from './use-download-pdf-diagnostic';

type Props = {
  organization: Pick<ToolsOrganizationsT, 'id' | 'email'>;
  project: Pick<ToolsProjectsT, 'id' | 'name'>;
  disabled?: boolean;
  withConfig?: boolean;
};

export const DownloadPdfDiagnosticButton: FC<Props> = (props) => {
  const { organization, project, disabled = false, withConfig = false } = props;

  const download = useDownloadPDFDiagnostic();

  const onClickMenuItem = useCallback(
    (locale: LanguageCodeT) => {
      return () => {
        download({
          organization,
          project,
          locale,
        });
      };
    },
    [download, organization, project]
  );

  if (withConfig) {
    return (
      <DownloadPdfButton
        organization={organization}
        project={project}
        disabled={disabled}
      />
    );
  }

  return (
    <CascadingHoverMenus
      popupId="download"
      variant="popover"
      button={(props) => (
        <IconButton
          {...props}
          disabled={disabled}
          sx={{ opacity: disabled ? 0.5 : 1 }}
        >
          <Download color="gray" />
        </IconButton>
      )}
    >
      <CascadingMenuItem onClick={onClickMenuItem(LanguageCode.Enum.fr)}>
        <Trans>Français</Trans>
      </CascadingMenuItem>
      <CascadingMenuItem onClick={onClickMenuItem(LanguageCode.Enum.fr)}>
        <Trans>Anglais</Trans>
      </CascadingMenuItem>
    </CascadingHoverMenus>
  );
};
